import * as v from 'valibot';

export const FileSchema = v.object({
	id: v.number(),
	type: v.string(),
	originalName: v.string(),
	link: v.string(),
	size: v.number(),
});
